import Vue from 'vue'
import Dialogs from '@common/vue-plugins/dialogs'
import Moment from '@common/vue-plugins/moment'
import { VueJanusPlugin } from '@common/vue-plugins/janus/vue-plugin'

Vue.use(Dialogs)
Vue.use(VueJanusPlugin)
Vue.use(Moment)
